var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttributesSmall = function SvgAttributesSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#8A8AA3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M5.332 8h.006m2.658 0h.006m2.657 0h.006M12 14c.822 0 1.487-.768 1.487-1.714 0-1.499-.066-2.495.962-3.68a.95.95 0 0 0 0-1.212c-1.028-1.185-.962-2.181-.962-3.68C13.487 2.768 12.822 2 12 2M3.999 14c-.822 0-1.488-.768-1.488-1.714 0-1.499.067-2.495-.961-3.68a.95.95 0 0 1 0-1.212c1.005-1.159.961-2.167.961-3.68C2.511 2.768 3.177 2 4 2"
  })));
};
export default SvgAttributesSmall;